<template>
  <div>
    <b-row :class="rowClass" :style="rowStyle">
      <div :class="headerClass(row)">
        <span :style="'padding-left: ' + (level * 1.28571) + 'em'">
          <i class="fa fa-fw" :class="{
            'fa-plus-square-o': collapsed && row.children && row.children.length,
            'fa-minus-square-o': !collapsed && row.children && row.children.length
          }" @click.prevent="collapsed = !collapsed"></i>
          <span v-b-tooltip.hover :title="row.translation">
            {{ row.translation }}
          </span>
          <template v-if="row.options.note">
            <i
              class="fa fa-fw fa-info-circle text-primary"
              v-b-tooltip.hover
              :title="row.options.note"></i>
          </template>
        </span>
      </div>
      <template v-for="(col, index) in columns">
        <slot name="value" :row="row" :col="col" :index="index"></slot>
      </template>
    </b-row>
    <div :class="{ 'd-none': collapsed }">
      <template v-for="subrow in row.children">
        <table-report-row
          :row="subrow"
          :columns="columns"
          :level="level + 1"
          :header-class="headerClass">
          <template v-slot:value="{ row: r, col: c, index: i }">
            <slot name="value" :row="r" :col="c" :index="i"></slot>
          </template>
        </table-report-row>
      </template>
    </div>
  </div>
</template>
<script>
import { uuid } from 'core/utils';

export default {
  props: {
    columns: {
      type: Array
    },

    row: {
      type: Object
    },

    level: {
      type: Number,
      default: 0
    },

    headerClass: {
      type: Function,
      default: (row) => 'col text-truncate'
    },
  },

  data() {
    return {
      collapsed: false
    };
  },

  computed: {
    rowClass() {
      const ret = {
        'font-weight-bold': this.row.options.bold,
        'border-top border-dark': this.row.options.borderTop,
        'border-bottom border-dark': this.row.options.borderBottom,
        //'align-content-center': true,
        'py-0': true,
      };

      if (this.row.options.variant) {
        ret['text-' + this.row.options.variant] = true;
      }

      return ret;
    },

    rowStyle() {
      const ret = {};
      if (this.row.options.bgColor) {
        ret['background-color'] = this.row.options.bgColor;
      }
      return ret;
    }
  },

  methods: {
    uuid() {
      return uuid();
    }
  }
}
</script>
